import { call, put, takeEvery } from "redux-saga/effects";
import { debtLoadService } from "../../services/debt-load-service";
import {
  CALCULATE_DEBT_LOAD_REQUEST,
  DEBTLOAD_LIST_REQUEST,
  FETCH_DEBT_LOAD_CALCULATE_REQUEST,
  FETCH_DEBT_LOAD_REPORT_REQUEST,
  GENERATE_DEBT_OVERLOAD_REPORT,
  GET_CLIENT_LAST_DEBT_LOAD_REQUEST,
  GET_DEBT_LOAD_GROUP_REQUEST,
  UPDATE_DEBT_LOAD_GROUP_REQUEST,
} from "../actions/actionTypes";
import {
  fetchDebtLoadCalculateFailed,
  fetchDebtLoadCalculateSuccess,
  fetchDebtLoadReportFailed,
  fetchDebtLoadReportSuccess,
  getClientLastDebtLoadFailed,
  getClientLastDebtLoadSuccess,
  getDebtLoadGroupSuccess,
  getDebtLoadListFailed,
  getDebtLoadListSuccess,
  updateDebtLoadGroupFailed,
  updateDebtLoadGroupSuccess,
} from "../actions/debtLoadAction";
import { messages } from "../../helpers/messages";
import { reportService } from "../../services/report-service";
import { generatePrintedForm } from "../../helpers/common";
import { requestForCalculationFailed } from "../actions/quickCalculationAction";
import { transformFormData } from "../../components/common/DebtLoadCalculation";

const getDebtLoadList = async (data) => {
  try {
    const response = await debtLoadService.getDebtLoadList(data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const getDebtLoadGroup = async (data) => {
  try {
    const response = await debtLoadService.getDebtLoadGroup(data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const putDebtLoadGroup = async (data) => {
  try {
    const response = await debtLoadService.putDebtLoadGroup(data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const fetchDebtLoadCalculation = async (data) => {
  try {
    const response = await debtLoadService.getDebtLoadClientCalculate(data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const fetchClientLastDebtLoad = async (data) => {
  try {
    const response = await debtLoadService.getClientLastDebtLoad(data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const generateReport = async (code, data) => {
  try {
    const response = await reportService.generateDebtOverloadReport(code, data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const fetchDebtReport = async (data) => {
  try {
    const response = await reportService.fetchDebtReport(data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const handleError = (error) => {
  if (error.response) {
    let errorData = error.response.data;
    let commonError = messages["0"];
    if (errorData.errorCode) {
      commonError = messages[errorData.errorCode];
    }
    window.scrollTo(0, 0);
    throw commonError;
  }
};

function* fetchDebtLoadList(action) {
  try {
    const { date } = action.payload;
    const { configGroups } = yield call(getDebtLoadList, { date });
    yield put(getDebtLoadListSuccess(configGroups));
  } catch (error) {
    yield put(getDebtLoadListFailed(error));
  }
}

function* getDebtLoadGroupList(action) {
  try {
    const { groupName } = action.payload;
    const { values } = yield call(getDebtLoadGroup, { groupName });
    yield put(getDebtLoadGroupSuccess(values));
  } catch (error) {
    yield put(getDebtLoadListFailed(error));
  }
}

function* updateDebtLoadGroup(action) {
  try {
    const { groupName, values } = action.payload;
    const response = yield call(putDebtLoadGroup, { groupName, values });
    yield put(updateDebtLoadGroupSuccess(response));
    yield call(fetchDebtLoadList, { payload: {} });
  } catch (error) {
    yield put(updateDebtLoadGroupFailed(error));
  }
}

function* getDebtLoadCalculation(action) {
  try {
    const { clientId, values } = action.payload;
    const response = yield call(fetchDebtLoadCalculation, { clientId, values });
    yield put(fetchDebtLoadCalculateSuccess(response));
  } catch (error) {
    if(error === messages['19003']) {
      yield put(requestForCalculationFailed(error))
    } else {
      yield put(fetchDebtLoadCalculateFailed(error));
    }
  }
}

function* getClientLastDebtLoad(action) {
  try {
    const { clientId } = action.payload;
    const response = yield call(fetchClientLastDebtLoad, { clientId });
    yield put(getClientLastDebtLoadSuccess(response));
  } catch (error) {
    yield put(getClientLastDebtLoadFailed(error.message));
  }
}

function* generateDebtOverloadReport(action) {
  try {
    const { code, reportData, filename } = action.payload;
    const generatedAct = yield call(() => generateReport(code, reportData));
    yield call(() => generatePrintedForm(generatedAct, filename));
  } catch (error) {
    yield put(getDebtLoadListFailed(error));
  }
}

function* fetchDebtLoadReport(action) {
  try {
    const response = yield call(fetchDebtReport, action.payload);
    yield put(fetchDebtLoadReportSuccess(response));
  } catch (error) {
    yield put(fetchDebtLoadReportFailed(error.message));
  }
}

function* calculateDebtLoad(action) {
  try {
    const { clientId, amount, previousDealId, currentDealDuration } = action.payload;

    const clientDebtLoadData = yield call(fetchClientLastDebtLoad, { clientId });
      const payload = {
        ...clientDebtLoadData,
        currentDealAmount: amount,
        clientId,
        previousDealId,
        currentDealDuration
      };
      
      const transformedData = transformFormData(payload);
     
      yield call(getDebtLoadCalculation, { payload: { clientId, values: transformedData } });
  } catch (error) {
    yield put(fetchDebtLoadCalculateFailed(error.message));
  }
}

function* getDebtLoadListSaga() {
  yield takeEvery(DEBTLOAD_LIST_REQUEST, fetchDebtLoadList);
}

function* getDebtLoadGroupSaga() {
  yield takeEvery(GET_DEBT_LOAD_GROUP_REQUEST, getDebtLoadGroupList);
}

function* updateDebtLoadListSaga() {
  yield takeEvery(UPDATE_DEBT_LOAD_GROUP_REQUEST, updateDebtLoadGroup);
}

function* getDebtLoadCalculationSaga() {
  yield takeEvery(FETCH_DEBT_LOAD_CALCULATE_REQUEST, getDebtLoadCalculation);
}

function* getClientLastDebtLoadSaga() {
  yield takeEvery(GET_CLIENT_LAST_DEBT_LOAD_REQUEST, getClientLastDebtLoad);
}

function* generateDebtOverLoadReportSaga() {
  yield takeEvery(GENERATE_DEBT_OVERLOAD_REPORT, generateDebtOverloadReport);
}

function* fetchDebtLoadReportSaga() {
  yield takeEvery(FETCH_DEBT_LOAD_REPORT_REQUEST, fetchDebtLoadReport);
}

function* calculateDebtLoadSaga() {
  yield takeEvery(CALCULATE_DEBT_LOAD_REQUEST, calculateDebtLoad);
}

export {
  getDebtLoadListSaga,
  updateDebtLoadListSaga,
  getDebtLoadCalculationSaga,
  getClientLastDebtLoadSaga,
  getDebtLoadGroupSaga,
  generateDebtOverLoadReportSaga,
  fetchDebtLoadReportSaga,
  calculateDebtLoadSaga
};
